module.exports = __webpack_public_path__ + "img/wave-3.c03e8567.png";